import React from "react";
import Layout from "../../Layout";
import HeaderReports from "../HeaderReports";
import ListReceivedMessage from "./ListReceivedMessage";
import SearchReceivedMessage from "./SearchReceivedMessage";
import GuideMessageStatus from "../MessageStatus/GuideMessageStatus";

const ReceivedMessage = () => {
  return (
    <Layout>
      <HeaderReports />
      <ListReceivedMessage />
      <SearchReceivedMessage />
      <GuideMessageStatus />
    </Layout>
  );
};

export default ReceivedMessage;
